import React from 'react';

const ReactionUpVote = () => (
  <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M14 6.79773C14 6.17752 13.7123 5.5924 13.221 5.21374L7.96556 1.16246C7.68525 0.945847 7.31313 0.945847 7.03444 1.16246L1.77895 5.21374C1.28774 5.5924 1 6.17752 1 6.79773V8L7.5 2.98753L14 8V6.79773Z'
      fill='#00FC92'
    />
    <path
      d='M13 13.0002H2C1.44772 13.0002 1 12.5524 1 12.0002V10L6.89029 5.46901C7.24974 5.19251 7.75026 5.19251 8.10971 5.46901L14 10.0001V12.0002C14 12.5524 13.5523 13.0002 13 13.0002Z'
      fill='#00FC92'
    />
  </svg>
);

export default ReactionUpVote;
